import {
  CardContainer,
  Container,
  ContentContainer,
  ContentContainerColumn,
  Form,
  FormSection,
} from 'uikit/layout'
import { Field, Formik } from 'formik'
import { Button } from 'uikit'
import { useFetchSettings } from './services/useFetchSettings'
import { useUpdateSettings } from './services/useUpdateSettings'
import { SwitchForm } from 'uikit/FormStateComponents/SwitchForm'

export const Settings = () => {
  const { data, isPending: isLoadingFetchSettings } = useFetchSettings()
  const dataSettings = data ? data[0] : {}
  const { mutate: updateSettings, isPending: isLoadingUpdate } = useUpdateSettings()

  const isLoading = isLoadingFetchSettings || isLoadingUpdate

  const handleForm = (values) => {
    const payload = {
      identityRAOn: values?.identityRAOn ? 1 : 0,
      identityRFOn: values?.identityRFOn ? 1 : 0,
      outRARFCardOn: values?.outRARFCardOn ? 1 : 0,
      payRFRACardOn: values?.payRFRACardOn ? 1 : 0,
      payRFRATelOn: values?.payRFRATelOn ? 1 : 0,
      payRFRBelCardOn: values?.payRFRBelCardOn ? 1 : 0,
      referralOn: values?.referralOn ? 1 : 0,
      identityRequestRFOn: values?.identityRequestRFOn ? 1 : 0,
      identityRequestRAOn: values?.identityRequestRAOn ? 1 : 0,
      payRFRAIdBank2CardOn: values?.payRFRAIdBank2CardOn ? 1 : 0,
      identityIDXOn: values?.identityIDXOn ? 1 : 0,
      payQROn: values?.payQROn ? 1 : 0,
      accountTopupOn: values?.accountTopupOn ? 1 : 0,
      sbpTopupOn: values?.sbpTopupOn ? 1 : 0,
      payUzPhoneOn: values?.payUzPhoneOn ? 1 : 0,
      payUzCardOn: values?.payUzCardOn ? 1 : 0,
    }
    updateSettings(payload)
  }

  return (
    <Container>
      <CardContainer indentTop={120} isHideBack>
        <ContentContainer>
          <ContentContainerColumn>
            <Formik
              initialValues={{
                identityRAOn: dataSettings?.identityRAOn === 1,
                identityRFOn: dataSettings?.identityRFOn === 1,
                outRARFCardOn: dataSettings?.outRARFCardOn === 1,
                payRFRACardOn: dataSettings?.payRFRACardOn === 1,
                payRFRATelOn: dataSettings?.payRFRATelOn === 1,
                payRFRBelCardOn: dataSettings?.payRFRBelCardOn === 1,
                referralOn: dataSettings?.referralOn === 1,
                identityRequestRFOn: dataSettings?.identityRequestRFOn === 1,
                identityRequestRAOn: dataSettings?.identityRequestRAOn === 1,
                payRFRAIdBank2CardOn: dataSettings?.payRFRAIdBank2CardOn === 1,
                identityIDXOn: dataSettings?.identityIDXOn === 1,
                payQROn: dataSettings?.payQROn === 1,
                accountTopupOn: dataSettings?.accountTopupOn === 1,
                sbpTopupOn: dataSettings?.sbpTopupOn === 1,
                payUzPhoneOn: dataSettings?.payUzPhoneOn === 1,
                payUzCardOn: dataSettings?.payUzCardOn === 1,
              }}
              enableReinitialize
              onSubmit={handleForm}
            >
              {(props) => (
                <Form
                  onSubmit={props.handleSubmit}
                  footer={
                    <Button type="submit" colorPalette="orange" loading={isLoading}>
                      Обновить
                    </Button>
                  }
                >
                  <FormSection>
                    <Field
                      size="lg"
                      name="payRFRATelOn"
                      component={SwitchForm}
                      label="Перевод РФ-РА по телефону"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="payRFRACardOn"
                      component={SwitchForm}
                      label="Перевод РФ-РА на карту"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="outRARFCardOn"
                      component={SwitchForm}
                      label="Перевод РА-РФ"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="payRFRBelCardOn"
                      component={SwitchForm}
                      label="Перевод РФ-РБ на карту"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="identityRAOn"
                      component={SwitchForm}
                      label="ИД РА"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="identityRFOn"
                      component={SwitchForm}
                      label="ИД РФ"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="identityRequestRFOn"
                      component={SwitchForm}
                      label="Запросы идентификации РФ"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="identityRequestRAOn"
                      component={SwitchForm}
                      label="Запросы идентификации РА"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="referralOn"
                      component={SwitchForm}
                      label="Бонусная программа"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="payRFRAIdBank2CardOn"
                      component={SwitchForm}
                      label="Переводы по номеру карты в IDbank"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="identityIDXOn"
                      component={SwitchForm}
                      label="Идентификация IDX"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="payQROn"
                      component={SwitchForm}
                      label="Оплата по QR-коду"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="accountTopupOn"
                      component={SwitchForm}
                      label="Пополнение счета с карты РФ"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="sbpTopupOn"
                      component={SwitchForm}
                      label="Пополнение через СБП me2me"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="payUzPhoneOn"
                      component={SwitchForm}
                      label="Перевод РФ - Узбекистан по телефону"
                      disabled={isLoading}
                    />
                    <Field
                      size="lg"
                      name="payUzCardOn"
                      component={SwitchForm}
                      label="Перевод РФ - Узбекистан на карту"
                      disabled={isLoading}
                    />
                  </FormSection>
                </Form>
              )}
            </Formik>
          </ContentContainerColumn>
        </ContentContainer>
      </CardContainer>
    </Container>
  )
}
